import { defineMessages } from "react-intl";

export const giftCardUpdateInfoCardMessages = defineMessages({
  title: {
    id: "Eh6KYS",
    defaultMessage: "Card information",
    description: "info card title",
  },
  creationLabel: {
    id: "/AbHy4",
    defaultMessage: "Creation",
    description: "creation label",
  },
  orderNumberLabel: {
    id: "9TbDQD",
    defaultMessage: "Order number",
    description: "order number label",
  },
  productLabel: {
    id: "kc4c4d",
    defaultMessage: "Product bought to get gift card",
    description: "product label",
  },
  issuedByLabel: {
    id: "V+h02n",
    defaultMessage: "Issued by",
    description: "issued by label",
  },
  issuedByAppLabel: {
    id: "F08wV2",
    defaultMessage: "Issued by extension",
    description: "issued by app label",
  },
  boughtByLabel: {
    id: "Jo01VZ",
    defaultMessage: "Bought by",
    description: "bought by label",
  },
  usedByLabel: {
    id: "kS5Qgk",
    defaultMessage: "Used by",
    description: "used by label",
  },
});
